// mobile-dock.js - Clean Final Version

document.addEventListener('DOMContentLoaded', function () {

    const dockItems = document.querySelectorAll('.yv-dock-item');
    const shopDockButton = document.querySelector('.yv-dock-item.mobileMenu[data-mobile-menu]');

    /* ==============================
       ACTIVE STATE HANDLING
    ============================== */
    dockItems.forEach(item => {
        item.addEventListener('click', function () {

            // Remove active from all items
            dockItems.forEach(i => i.classList.remove('active'));

            // Add active to clicked item
            this.classList.add('active');
        });
    });

    /* ==============================
       SHOP BUTTON (OPEN MENU)
    ============================== */
    if (shopDockButton) {
        shopDockButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            // Set active state manually for Shop
            dockItems.forEach(i => i.classList.remove('active'));
            this.classList.add('active');

            const originalMenuButton = document.querySelector('button[data-mobile-menu]:not(.yv-dock-item)');

            if (originalMenuButton) {
                originalMenuButton.click();
            } else {
                openMobileMenu();
            }
        });
    }

    function openMobileMenu() {
        const mobileMenu = document.getElementById('mobileMenu');

        if (mobileMenu) {
            mobileMenu.classList.add('active', 'open');
            mobileMenu.style.transform = 'translateX(0)';
            mobileMenu.style.visibility = 'visible';
            document.body.style.overflow = 'hidden';
        }
    }

    /* ==============================
       REMOVE X BUTTON (CLOSE ICON)
    ============================== */
    function removeCloseButton() {
        const mobileMenu = document.getElementById('mobileMenu');
        if (!mobileMenu) return;

        const closeButtons = mobileMenu.querySelectorAll('button, .close, .close-btn, [class*="close"], svg');

        closeButtons.forEach(btn => {
            const text = btn.textContent || '';

            if (
                text.includes('×') ||
                text.includes('✕') ||
                btn.innerHTML.includes('path d="M18') ||
                btn.closest('.close-menu-btn')
            ) {
                btn.style.display = 'none';
            }
        });

        const existingX = mobileMenu.querySelector('.close-menu, .menu-close, [aria-label="Close"]');
        if (existingX) existingX.style.display = 'none';
    }

    /* ==============================
       OBSERVER (MENU OPEN DETECT)
    ============================== */
    const observer = new MutationObserver(() => {
        const menu = document.getElementById('mobileMenu');

        if (menu && menu.classList.contains('active')) {
            setTimeout(removeCloseButton, 50);
        }
    });

    observer.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true
    });

    /* ==============================
       FALLBACK CLICK LISTENER
    ============================== */
    document.addEventListener('click', function (e) {
        if (e.target.closest('button[data-mobile-menu]')) {
            setTimeout(removeCloseButton, 100);
        }
    });

    console.log('✅ Mobile Dock Loaded Successfully');
});